(function () {
    'use strict';

    // NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
    if (typeof window === 'undefined') {

        timePeriod(
            module.exports,
            require('../../enums/timePeriod.js'),
            require('./timezone.js'),
            require('../../../lib/riq-moment.js'),
            require('lodash')
        );

    } else {
        RivalIQ.module('utils.timePeriod');

        timePeriod(
            RivalIQ.utils.timePeriod,
            RivalIQ.enums.timePeriod,
            RivalIQ.utils.timezone,
            window.moment,
            window._
        );
    }

    function timePeriod(utils, enums, timezoneUtils, moment, _) {

        utils.bounds = enums.bounds;
        utils.interval = enums.interval;
        utils.period = enums.period;
        utils.type = enums.type;

        /**
         * Rounds a moment date to start of day.
         * @param {Moment} date
         * @return {Moment}
         */
        function toStartOfDay(date) {

            return date.startOf('day');
        }

        /**
         * Rounds a moment date to end of day.
         * @param {Moment} date
         * @returns {Moment}
         */
        function toEndOfDay(date) {

            return date.endOf('day');
        }

        const properties = [
            {
                name: 'mainPeriodStart',
                format: toStartOfDay
            },
            {
                name: 'mainPeriodEnd',
                format: toEndOfDay
            },
            {
                name: 'comparePeriodStart',
                format: toStartOfDay
            },
            {
                name: 'comparePeriodEnd',
                format: toEndOfDay
            }
        ];

        /**
         * Gets the period durations for a given time period, and interval.
         * @param timePeriod
         * @param interval
         * @param [rounded]
         */
        utils.getPeriodDurationsForInterval = function (timePeriod, interval, rounded) {

            const getDuration = function (start, end) {

                return (!start || !end ? 0 : Math.ceil(moment.utc(end).diff(moment.utc(start), interval, !rounded)));
            };

            return {
                main: getDuration(timePeriod.mainPeriodStart, timePeriod.mainPeriodEnd),
                compare: getDuration(timePeriod.comparePeriodStart, timePeriod.comparePeriodEnd)
            };
        };

        utils.getPeriodCount = function (start, end, interval) {
            interval = interval || enums.interval.daily;

            return (!start || !end ? 0 : 1 + end.clone().endOf(interval).diff(start.clone().startOf(interval), interval));
        };

        utils.uuid = function (timePeriod) {
            return _.map(properties, function (prop) {
                if (timePeriod[prop.name] && timePeriod[prop.name].format) {
                    return timePeriod[prop.name].format();
                } else {
                    return '';
                }
            }).join('.');
        };

        utils.isValid = function (timePeriod) {
            return !_.some(properties, function (prop) {
                return !timePeriod[prop.name].isValid();
            });
        };

        /**
         * Rehydrates a time period (i.e., converts string dates to moment dates).
         **/
        utils.rehydrate = function (timePeriod, timezone) {
            // we need to convert date strings into moment dates
            properties.forEach(function (property) {

                let existing = timePeriod[property.name];

                if (existing) {
                    existing = utils.convertToTz(moment.utc(existing), timezone);
                    timePeriod[property.name] = property.format(existing);
                }
            });

            // we also need to determine duration of periods
            timePeriod.mainPeriodDuration = timePeriod.mainPeriodEnd.diff(timePeriod.mainPeriodStart, 'days') + 1;

            // BUGBUG: this is a TEMPORARY fix for a critical issue caused by time periods that
            // do not have corresponding compare periods, this is merely a band aid...
            if (!timePeriod.comparePeriodEnd || !timePeriod.comparePeriodStart) {

                const tempTimePeriod = utils.createTimePeriodFromStartAndEnd(timePeriod.mainPeriodStart, timePeriod.mainPeriodEnd);
                _.extend(timePeriod, _.pick(tempTimePeriod, 'comparePeriodStart', 'comparePeriodEnd', 'comparePeriodDuration'));
            } else {

                timePeriod.comparePeriodDuration = timePeriod.comparePeriodEnd.diff(timePeriod.comparePeriodStart, 'days') + 1;
            }

            // if we don't have a display string, stick one on there
            if (typeof timePeriod.displayString === 'undefined') {

                timePeriod.displayString = 'Custom';
            }

            timePeriod.uuid = utils.uuid(timePeriod);

            return timePeriod;
        };

        /**
         * Deserializes a time period from a stringified object.
         **/
        utils.deserialize = function (timePeriod) {

            let parsedJSON;
            let hadError = false;
            try {
                parsedJSON = JSON.parse(timePeriod);
                if (typeof parsedJSON === 'object') {
                    utils.rehydrate(parsedJSON);
                }
            } catch (e) {
                hadError = true;
            }

            if (hadError || (parsedJSON && !parsedJSON.displayString)) {
                // uh oh, just make a new time period, default to 7 days)
                const timePeriods = RivalIQ.state.timePeriods;
                parsedJSON = _.clone(timePeriods.getDefinitionByType(timePeriods.types.LAST_SEVEN_DAYS));
            }
            return parsedJSON;
        };

        /**
         * Serializes a time period for XHR.
         **/
        utils.serializeForAjax = function (timePeriod) {
            const localTimePeriod = _.extend({}, timePeriod);
            _.each(localTimePeriod, function (value, key) {
                if (moment.isMoment(timePeriod[key])) {
                    localTimePeriod[key] = localTimePeriod[key].format('YYYY-MM-DD');
                }
            });
            return _.omit(localTimePeriod, 'uuid');
        };

        const fieldsOmittedFromSerialization = [
            'uuid'
        ];

        /**
         * Serializes a time period
         **/
        utils.serialize = function (timePeriod) {
            const object = _.omit(timePeriod, fieldsOmittedFromSerialization);
            const json = JSON.stringify(object);
            const result = encodeURIComponent(json);
            return result;
        };


        (function () {

            const getPeriodDisplayString = function (startDate, endDate, glue) {
                glue = glue || ' - ';
                if (!moment.isMoment(startDate)) {
                    startDate = moment(startDate);
                }
                if (!moment.isMoment(endDate)) {
                    endDate = moment(endDate);
                }

                const startYear = startDate.year();
                const endYear = endDate.year();

                let longDateFormat = utils.getLongDateFormat();
                if (_.startsWith(longDateFormat, 'Y')) {
                    longDateFormat = longDateFormat.slice(2);
                    // the first date has year info when date range is in the same year
                    // EX: 21.01.01 - 01.30.
                    const endDateFormat = startYear === endYear ? endDate.format(longDateFormat.slice(3)) : endDate.format(longDateFormat);
                    return startDate.format(longDateFormat) + glue + endDateFormat;
                }

                // same year format MM/DD, different year format MM/DD/YY (depending on locale)
                const startFormat = (startYear === endYear ? longDateFormat.slice(0, 5) : longDateFormat.slice(0, 8));
                return startDate.format(startFormat) + glue + endDate.format(longDateFormat.slice(0, 8));
            };

            /**
             * Gets a display string for a time period with optional glue.
             **/
            utils.getDisplayString = function (timePeriod, glue) {
                const start = getPeriodDisplayString(timePeriod.mainPeriodStart, timePeriod.mainPeriodEnd);
                const end = getPeriodDisplayString(timePeriod.comparePeriodStart, timePeriod.comparePeriodEnd);
                glue = glue || ' vs. ';
                return start + glue + end;
            };

            utils.getMainPeriodDisplayString = function (timePeriod) {
                return getPeriodDisplayString(timePeriod.mainPeriodStart, timePeriod.mainPeriodEnd);
            };

        }());

        /**
         * Translates a time period for use in various UI.
         **/
        utils.translate = function (timePeriod, selectedDisplayString) {
            const translatedTimePeriod = _.extend({}, timePeriod);

            // tell others this time period can be removed, since it is custom
            translatedTimePeriod.isDeletable = true;
            // generate the display string for the title bar, and elsewhere
            translatedTimePeriod.displayString = utils.getDisplayString(timePeriod);
            // set a selected display string
            translatedTimePeriod.selectedDisplayString = selectedDisplayString || 'Custom';
            // just add water...
            utils.rehydrate(translatedTimePeriod);

            return translatedTimePeriod;
        };

        /**
         * create a full time period object from just two dates defining a main period. assume an equal length compare period that abuts
         **/
        utils.createTimePeriodFromStartAndEnd = function (mainPeriodStart, mainPeriodEnd) {

            const item = {};
            item.mainPeriodStart = toStartOfDay(moment.utc(mainPeriodStart));
            item.mainPeriodEnd = toEndOfDay(moment.utc(mainPeriodEnd));
            const duration = item.mainPeriodEnd.diff(item.mainPeriodStart, 'days');
            item.mainPeriodDuration = duration + 1;

            item.comparePeriodEnd = toEndOfDay(item.mainPeriodStart.clone().subtract(1, 'days'));
            item.comparePeriodStart = toStartOfDay(item.comparePeriodEnd.clone().subtract(duration, 'days'));
            item.comparePeriodDuration = item.comparePeriodEnd.diff(item.comparePeriodStart, 'days') + 1;
            item.displayString = 'Custom';

            return item;
        };

        /**
         * Create a time period from a duration, with an optional main period end.
         * @param {Number} duration - The time period's duration in days.
         * @param {Date} [mainPeriodEnd=moment.utc()] - The end of the time period (defaults to UTC now).
         * @returns {Object} A time period.
         */
        utils.createTimePeriodFromDuration = function (duration, mainPeriodEnd) {
            mainPeriodEnd = (mainPeriodEnd) ? moment.utc(mainPeriodEnd) : moment.utc();
            // we subtract one from duration because we include end
            const mainPeriodStartDate = mainPeriodEnd.clone().subtract(duration - 1, 'days').toDate();
            const mainPeriodEndDate = mainPeriodEnd.toDate();
            const result = utils.createTimePeriodFromStartAndEnd(mainPeriodStartDate, mainPeriodEndDate);
            return result;
        };

        utils.typeToMainPeriodType = {};
        utils.typeToMainPeriodType[enums.type.LAST_SEVEN_DAYS] = enums.mainPeriodType.LAST_SEVEN_DAYS;
        utils.typeToMainPeriodType[enums.type.LAST_THIRTY_DAYS] = enums.mainPeriodType.LAST_THIRTY_DAYS;
        utils.typeToMainPeriodType[enums.type.LAST_NINETY_DAYS] = enums.mainPeriodType.LAST_NINETY_DAYS;
        utils.typeToMainPeriodType[enums.type.YESTERDAY] = enums.mainPeriodType.YESTERDAY;
        utils.typeToMainPeriodType[enums.type.THIS_WEEK] = enums.mainPeriodType.THIS_WEEK;
        utils.typeToMainPeriodType[enums.type.LAST_WEEK] = enums.mainPeriodType.LAST_WEEK;
        utils.typeToMainPeriodType[enums.type.THIS_MONTH] = enums.mainPeriodType.THIS_MONTH;
        utils.typeToMainPeriodType[enums.type.LAST_MONTH] = enums.mainPeriodType.LAST_MONTH;
        utils.typeToMainPeriodType[enums.type.THIS_QUARTER] = enums.mainPeriodType.THIS_QUARTER;
        utils.typeToMainPeriodType[enums.type.LAST_QUARTER] = enums.mainPeriodType.LAST_QUARTER;

        /**
         * Create a time period based on a utils.type.XXX value (LAST_30_DAYS, THIS_WEEK, etc).
         * @param {Number} type - Supplies the utils.type value.
         * @returns {Object} A time period if successful, null otherwise.
         */
        utils.createTimePeriodFromType = function (type, forceUtc) {
            const mainPeriodDefinition = enums.mainPeriodDefinition[utils.typeToMainPeriodType[type]];
            if (!mainPeriodDefinition) {
                return null;
            }

            const mainPeriodValidWith = mainPeriodDefinition.apiValidWith[enums.periodType.COMPARE_PERIOD];
            const comparePeriodDefinition = enums.comparePeriodDefinition[mainPeriodValidWith];
            if (!comparePeriodDefinition) {
                return null;
            }

            const mainPeriodDates = mainPeriodDefinition.dates(forceUtc);
            const comparePeriodDates = comparePeriodDefinition.dates(mainPeriodDates);

            const item = {};

            item.mainPeriodStart = toStartOfDay(mainPeriodDates[0]);
            item.mainPeriodEnd = toEndOfDay(mainPeriodDates[1]);
            item.mainPeriodDuration = item.mainPeriodEnd.diff(item.mainPeriodStart, 'days') + 1;

            item.comparePeriodStart = toStartOfDay(comparePeriodDates[0]);
            item.comparePeriodEnd = toEndOfDay(comparePeriodDates[1]);
            item.comparePeriodDuration = item.comparePeriodEnd.diff(item.comparePeriodStart, 'days') + 1;
            item.displayString = mainPeriodDefinition.name;

            return item;
        };

        /**
         * Create a uniform date range display string.
         * @param {Object} timePeriod
         * @param {Boolean} mainOnly - main period only
         * @param {Number} timePeriodType - display type for timePeriod
         * @param {String} timezone - optional, if specified will add the timezone's name in parens after the display string.
         */
        utils.getTimePeriodDisplayString = function (timePeriod, timePeriodType, timezone) {
            const types = enums.type;

            if (timePeriodType === types.NOT_AVAILABLE || timePeriodType === types.LOADING) {
                return '';
            }

            let displayString;
            let tzReferenceDate;

            if (timePeriodType === types.TODAY) {
                displayString = utils.getAsOfDisplayString();
                tzReferenceDate = new Date();
            } else {

                const dateDisplayFormat = 'MMM D, YYYY';
                timePeriod = _.clone(timePeriod);
                utils.rehydrate(timePeriod);

                if (timePeriod.mainPeriodStart.format(dateDisplayFormat) === timePeriod.mainPeriodEnd.format(dateDisplayFormat)) {
                    displayString = timePeriod.mainPeriodEnd.format(dateDisplayFormat);
                } else {
                    displayString = `${timePeriod.mainPeriodStart.format(dateDisplayFormat)} - ${timePeriod.mainPeriodEnd.format(dateDisplayFormat)}`;
                }
                tzReferenceDate = timePeriod.mainPeriodEnd;
            }

            if (timezone) {
                displayString += ` ${moment.tz(tzReferenceDate, timezone).zoneName()}`;
            }

            return displayString;
        };

        /**
         * Creates a uniform "As of" date string
         * @param {Object} timePeriod - will use mainPeriodEnd if provided, otherwise moment.utc().
         * @returns {string}
         */
        utils.getAsOfDisplayString = function (timePeriod) {
            const date = (timePeriod ? moment.utc(timePeriod.mainPeriodEnd) : moment.utc());
            return `As of ${date.format('MMM D, YYYY')}`;
        };

        /**
         * Creates a static time period from a hydrated object.
         * @params {object} timePeriod
         * @returns {object} A dehydrated, static time period object.
         */
        utils.toStatic = function (timePeriod) {
            return JSON.parse(JSON.stringify(timePeriod));
        };

        utils.hasEqualMainAndComparePeriodDurations = function (timePeriod) {
            return moment.utc(timePeriod.mainPeriodEnd).diff(timePeriod.mainPeriodStart, 'days') ===
                moment.utc(timePeriod.comparePeriodEnd).diff(timePeriod.comparePeriodStart, 'days');
        };

        utils.setPeriod = function (timePeriod, periodType, periodId) {
            timePeriod = _.clone(timePeriod);
            const periods = _.clone(timePeriod.periods);
            periods[periodType] = periodId;

            // Reset other period types to valid configuration
            const period = RivalIQ.data.timePeriodDefinitions.get(periodType, periodId);

            _.each(_.values(enums.periodType), function (type) {
                if (type !== periodType) {
                    const validTypes = RivalIQ.data.timePeriodDefinitions.forPeriod(type, period);
                    if (!validTypes.get(periods[type])) {
                        periods[type] = validTypes.first().id;
                    }
                }
            });

            timePeriod.periods = periods;
            return utils.calculateDates(timePeriod);
        };

        utils.calculateDates = function (timePeriod) {
            timePeriod = _.clone(timePeriod);

            const mainPeriod = RivalIQ.data.timePeriodDefinitions.get(enums.periodType.MAIN_PERIOD, timePeriod.periods[enums.periodType.MAIN_PERIOD]);
            const mainPeriodDates = mainPeriod.getDates(undefined, _.get(timePeriod, ['dates', enums.periodType.MAIN_PERIOD]));
            const comparePeriod = RivalIQ.data.timePeriodDefinitions.get(enums.periodType.COMPARE_PERIOD, timePeriod.periods[enums.periodType.COMPARE_PERIOD]);

            timePeriod.dates = {
                1: comparePeriod.getDates(mainPeriodDates, _.get(timePeriod, ['dates', enums.periodType.COMPARE_PERIOD])),
                2: mainPeriodDates
            };

            return timePeriod;
        };

        utils.getLocale = function () {
            const broswerLanguage = _.get(window, ['navigator', 'userLanguage']) || _.get(window, ['navigator', 'language']);
            return (broswerLanguage && broswerLanguage.slice(0, 2)) || 'en';
        };

        utils.getLongDateFormat = function () {
            const me = this;
            const locale = me.getLocale();
            return _.get(moment.localeData(locale), ['_config', 'longDateFormat', 'L']);
        };

        utils.setPeriodDate = function (timePeriod, periodType, index, date) {
            timePeriod = _.clone(timePeriod);
            timePeriod.dates = _.clone(timePeriod.dates);

            if (date) {
                const localeLongDateFormat = utils.getLongDateFormat();
                timePeriod.dates[periodType][index] = moment.utc(date, localeLongDateFormat);
            }

            // Construct a flat array of in-order dates and mutate it to make
            // it monotonically increasing
            const periods = [enums.periodType.COMPARE_PERIOD, enums.periodType.MAIN_PERIOD];
            let dates = _.flatten(_.map(periods, function (period) {
                return timePeriod.dates[period];
            }));

            // all these dates must be dates/moment objects
            dates = _.map(dates, function (date) {
                return (moment.isMoment(date) ? date : moment.utc(date));
            });

            function idx(periodType, index) {
                return periods.indexOf(periodType) * 2 + index;
            }

            // Push dates after the changed date forward
            // Dates in a future periodType get push forward a day b/c otherwise
            // mainPeriod and comparePeriod would be set to the same day
            const limit = periods.length * 2;
            const fixedIdx = idx(periodType, index);
            let i;
            for (i = fixedIdx + 1; i < limit; i++) {
                if (i === 0) {
                    return;
                }

                if (i % 2 === 0 && dates[i] < moment.utc(dates[i - 1]).add(1, 'day')) {
                    dates[i] = moment.utc(dates[i - 1]).add(1, 'day');
                } else if (dates[i] < dates[i - 1]) {
                    dates[i] = moment.utc(dates[i - 1]);
                }
            }

            // Pull dates after the changed date backward
            // Dates in a prior periodType get pulled back a day b/c otherwise
            // mainPeriod and comparePeriod would be set to the same day
            for (i = fixedIdx - 1; i >= 0; i--) {
                if (i === limit - 1) {
                    return;
                }

                if (i % 2 === 1 && dates[i] > moment.utc(dates[i + 1]).subtract(1, 'day')) {
                    dates[i] = moment.utc(dates[i + 1]).subtract(1, 'day');
                } else if (dates[i] > dates[i + 1]) {
                    dates[i] = moment.utc(dates[i + 1]);
                }
            }

            // Turn the flat array back into a nested period set
            _.each(periods, function (period, i) {
                _.each(_.range(0, 2), function (j) {
                    timePeriod.dates[period][j] = dates[i * periods.length + j];
                });
            });

            return utils.calculateDates(timePeriod);
        };

        const dateMap = {};
        dateMap[enums.periodType.MAIN_PERIOD] = {};
        dateMap[enums.periodType.MAIN_PERIOD][0] = 'mainPeriodStart';
        dateMap[enums.periodType.MAIN_PERIOD][1] = 'mainPeriodEnd';
        dateMap[enums.periodType.COMPARE_PERIOD] = {};
        dateMap[enums.periodType.COMPARE_PERIOD][0] = 'comparePeriodStart';
        dateMap[enums.periodType.COMPARE_PERIOD][1] = 'comparePeriodEnd';

        utils.serializeDates = function (timePeriod) {
            const id = RivalIQ.data.timePeriodDefinitions.get(enums.periodType.MAIN_PERIOD, timePeriod.periods[enums.periodType.MAIN_PERIOD]).get('timePeriodId');
            let definition = RivalIQ.state.timePeriods.getByType(id);
            if (id === enums.type.CUSTOM) { // Ew
                definition = {
                    id: enums.type.CUSTOM,
                    periods: timePeriod.periods
                };
            }
            definition = _.clone(definition);
            definition.dates = {};
            definition.periods = timePeriod.periods;

            _.each(timePeriod.dates, function (dates, periodType) {
                _.each(dates, function (date, i) {
                    const dString = date.format('YYYY-MM-DD');
                    definition[dateMap[periodType][i]] = dString;
                    _.set(definition.dates, [periodType, i], dString);
                });
            });

            if (!definition.displayString) {
                definition.displayString = utils.getDisplayString(definition);
            }

            return definition;
        };

        utils.convertToTz = (date, timezone) => {
            if (!timezoneUtils) {
                if (typeof window === 'undefined') {
                    // Including these here to get around some module loading pain.
                    timezoneUtils = require('../../../public/modules/utils/timezone.js');
                } else {
                    timezoneUtils = RivalIQ.utils.timezone;
                }
            }
            return timezoneUtils.convertUtcDateToTz(date, timezone);
        };

        utils.isDisabled = function (timePeriod) {
            return _.get(timePeriod, 'disabled', !_.get(timePeriod, 'selectable', true));
        };

        utils.convertTimePeriod = function (timePeriod) {
            // NOTE: don't call clone deep as it creates funky objects for which moment.isMoment
            // returns true (but are otherwise not actually moment objects).
            timePeriod = _.clone(timePeriod);

            // if we don't have period types defined, assume they are custom
            if (!timePeriod.periods) {
                timePeriod.periods = {};
                timePeriod.periods[enums.periodType.MAIN_PERIOD] = enums.mainPeriodType.CUSTOM;
                timePeriod.periods[enums.periodType.COMPARE_PERIOD] = enums.comparePeriodType.CUSTOM;
            }

            timePeriod.dates = {};
            _.each(dateMap, function (dates, type) {
                _.each(dates, function (key, date) {
                    _.set(timePeriod.dates, [type, date], timePeriod[key]);
                });
            });

            return timePeriod;
        };

        function padFront(array, padCount) {
            const padding = _.map(_.range(0, padCount), _.constant(null));
            return padding.concat(array);
        }

        function padBack(array, padCount) {
            const padding = _.map(_.range(0, padCount), _.constant(null));
            return array.concat(padding);
        }

        function groupByWeek(array, date, pad) {
            const daysInWeek = 7;
            const offset = daysInWeek - date.day();

            let start = _.take(array, offset);
            if (pad) {
                start = padFront(start, daysInWeek - offset);
            }

            const grouping = [start].concat(_.chunk(_.drop(array, offset), daysInWeek));

            if (pad) {
                const last = _.last(grouping);
                grouping[grouping.length - 1] = padBack(last, daysInWeek - last.length);
            }

            return grouping;
        }

        function groupByMonth(array, date, pad) {
            let daysInMonth = 0;
            const result = [];

            let offset = 0;

            let totalDaysInMonth;
            if (pad) {
                daysInMonth = moment.utc(date).endOf('month').diff(date, 'day') + 1;
                const monthOffset = moment.utc(date).date() - 1;
                result.push(padFront(_.take(array, daysInMonth), monthOffset));
                offset = daysInMonth;
            }

            while (offset < array.length - 1) {
                date.add(daysInMonth, 'days');
                daysInMonth = moment.utc(date).endOf('month').diff(date, 'day') + 1;
                result.push(_.slice(array, offset, offset + daysInMonth));
                offset += daysInMonth;
            }

            if (pad) {
                totalDaysInMonth = moment.utc(date).daysInMonth();
                const last = _.last(result);
                result[result.length - 1] = padBack(last, totalDaysInMonth - last.length);
            }

            return result;
        }

        /*
         * Groups the passed in array of daily values by the provided interval
         * given a start date. Note that group lengths are unlikely to be equal
         */
        utils.groupByInterval = function (array, interval, startDate, pad) {
            if (!interval || interval === enums.interval.daily) {
                return array;
            }

            const date = moment.utc(startDate);
            if (interval === enums.interval.weekly) {
                return groupByWeek(array, date, pad);
            }

            if (interval === enums.interval.monthly) {
                return groupByMonth(array, date, pad);
            }
        };

        utils.numCompletePeriods = function (mainPeriodStart, mainPeriodEnd, interval) {
            mainPeriodStart = moment.utc(mainPeriodStart).startOf('day');
            mainPeriodEnd = moment.utc(mainPeriodEnd).endOf('day');

            const numInteriorIntervals = mainPeriodEnd.clone().startOf(interval).diff(mainPeriodStart.clone().endOf(interval), interval);
            let numCompleteIntervals = numInteriorIntervals;
            if (mainPeriodStart.isSame(mainPeriodStart.clone().startOf(interval))) {
                numCompleteIntervals++;
            }
            if (mainPeriodEnd.isSame(mainPeriodEnd.clone().endOf(interval)) && !mainPeriodEnd.isSame(mainPeriodStart.clone().endOf(interval))) {
                numCompleteIntervals++;
            }

            return numCompleteIntervals;
        };

        function adjustRange(range, bounds, keyFn, state) {
            return _.reduce([['start', -1], ['end', 1]], (memo, [type, delta]) => {
                const key = keyFn(type, state);
                const value = (bounds[type] === enums.bounds.exclusive ?
                    moment.utc(range[key]).add(delta, 'milliseconds') :
                    range[key]);
                return _.set(memo, key, value);
            }, {});
        }

        const rangeKeyFn = {
            dateRange: (type) => `${type}Date`,
            timePeriod: (type, period) => `${period}Period${_.capitalize(type)}`
        };

        // this method will adjust a `timePeriod` or a date range (defined by a
        // `startDate` and `endDate`) given a boundary definition (denoted by
        // a `start` or `end`). the method defaults to assuming that ALL dates
        // are specified and expected in UTC, and it makes sure that returned
        // dates are in UTC
        utils.adjustBounds = function (config) {
            const {bounds, timePeriod} = (config || {});

            if (!bounds || (!bounds.start && !bounds.end)) {
                throw new Error(`invalid bounds specified '${bounds}'`);
            }

            if (timePeriod) {
                const result = _.reduce(['main', 'compare'], (memo, period) => {
                    const value = adjustRange(timePeriod, bounds, rangeKeyFn.timePeriod, period);
                    return _.extend(memo, value);
                }, {});

                return {
                    timePeriod: _.defaults(result, timePeriod)
                };
            }

            if (!config.startDate && !config.endDate) {
                throw new Error(`a timePeriod or startDate and endDate must be specified`);
            }

            const result = adjustRange(config, bounds, rangeKeyFn.dateRange);

            return result;
        };

        utils.getQuidTopicTimeInterval = function (topic, timezone) {
            const {timezone: timezoneRange, timeInterval} = utils.getQuidTopicTimePeriod(topic, timezone);
            const {end, start} = timezoneRange;
            const endFormatString = `MM/DD/YY`;
            const startFormatString = (!moment.tz(start, timezone).diff(end, 'years') ? `MM/DD` : endFormatString);
            return `${_.chain(timeInterval).lowerCase().startCase().value()} (${moment.tz(start, timezone).format(startFormatString)} - ${moment.tz(end, timezone).format(endFormatString)})`;
        };

        function lastNOfPeriod(timezone = 'UTC', n = 0, period = 'days') {
            const endOfToday = moment.tz(timezone).endOf('day');
            return {
                start: moment.tz(endOfToday, timezone).subtract(n, period).startOf('day'),
                end: endOfToday
            };
        }

        const timeIntervalToPeriod = {
            'LAST_HOUR': ({timezone}) => lastNOfPeriod(timezone),
            'LAST_DAY': ({timezone}) => lastNOfPeriod(timezone),
            'LAST_WEEK': ({timezone}) => lastNOfPeriod(timezone, 7, 'days'),
            'LAST_MONTH': ({timezone}) => lastNOfPeriod(timezone, 1, 'months'),
            'LAST_SIX_MONTHS': ({timezone}) => lastNOfPeriod(timezone, 6, 'months'),
            'LAST_QUARTER': ({timezone}) => lastNOfPeriod(timezone, 3, 'months'),
            'LAST_YEAR': ({timezone}) => lastNOfPeriod(timezone, 1, 'years'),
            'LAST_(\\d+)YEARS': ({match, timezone}) => lastNOfPeriod(timezone, Number(_.nth(match, 1)), 'years'),
            'LAST_(\\d+)MONTHS': ({match, timezone}) => lastNOfPeriod(timezone, Number(_.nth(match, 1)), 'months'),
            'CUSTOM': ({fromDate, timezone, toDate}) => {
                return {
                    start: moment.tz(moment.utc(fromDate), timezone).startOf('day'),
                    end: moment.tz(moment.utc(toDate), timezone).endOf('day')
                };
            },
            'OPEN_END': ({fromDate, timezone}) => {
                return {
                    start: moment.tz(moment.utc(fromDate), timezone).startOf('day'),
                    end: moment.tz(timezone).endOf('day')
                };
            }
        };

        function timeIntervalToTimePeriod({fromDate, timeInterval, toDate, timezone}) {
            const key = _.find(_.keys(timeIntervalToPeriod), (key) => {
                const exp = new RegExp(`^${key}$`);
                return timeInterval.match(exp);
            });

            if (!key) {
                throw new Error(`unrecognized timeInterval '${timeInterval}'`);
            }

            const handler = timeIntervalToPeriod[key];
            const match = timeInterval.match(new RegExp(`^${key}$`));
            const ranges = _.reduce([['timezone', timezone], ['utc']], (memo, [k, tz = k]) => {
                const result = handler({
                    fromDate,
                    match,
                    timezone: tz,
                    toDate
                });

                return _.set(memo, k,
                    _.reduce(result,
                        (m, val, k) => _.set(m, k, val.toISOString(true)),
                        {}
                    )
                );
            }, {
                timeInterval,
                configured: {
                    end: toDate,
                    start: fromDate
                }
            });

            return ranges;
        }

        utils.getQuidTopicTimePeriod = function (topic, timezone) {
            const config = _.defaults({
                timezone: timezone
            }, topic);

            const result = timeIntervalToTimePeriod(config);

            return result;
        };
    }

})();
